import React from 'react'
import footerCellhub from"../image/footerCellhub.png";
import { useLocation } from 'react-router-dom';

export default function Footer() {
  const location = useLocation();
  const currentYear = new Date().getFullYear();
  const isApplicationPath = location.pathname === "/checkApplicationStatus" || location.pathname === "/applicationStatus" || location.pathname === "/updatesubmissionstatus" || location.pathname === "/emailSearch";

  return (
    <div className={`footer ${isApplicationPath  ? 'footeranother' : 'footer'}`}>
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-xs-12">
          <a >
            <img src={footerCellhub} alt="Cellhub" />
          </a>
        </div>
      </div>
      <p className="copyRight">©{currentYear} Cellhub.com, LLC all rights reserved.</p>
    </div>
  </div>
  )
}
